/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../components.ts"/>


module DealerwareWebComponents {

    "use strict";

    export class SettingsLoanerAgreementViewDirectiveController {

        public static $inject : string[ ] = ['$scope', '$state' ];

        private agreement: any;
        private unwatchAgreement: any;
        private unwatchAgreementPages: any;

        private selectedPage: any;

        private parentController: any;
        private loanerAgreementService: any;


        constructor(
            private $scope: ng.IScope,
            private $state: any
        ) {

            var that = this;

            this.unwatchAgreement = this.$scope.$watch( ( ) => {
                    return that.loanerAgreementService && that.loanerAgreementService.agreement
                },
                (agreement: any ) => {
                    if (! agreement) {
                        return;
                    }

                    that.agreement = agreement;

                }, true
            );

            this.unwatchAgreementPages = this.$scope.$watch( ( ) => {
                    return that.loanerAgreementService && that.loanerAgreementService.agreement
                        && that.loanerAgreementService.agreement.pages;
                },
                (pages: any ) => {

                    if (pages === undefined || that.selectedPage) {
                        return;
                    }

                    that.selectedPage = pages.find( ( page: any ) => {
                        return page.selected;
                    });
                }, true
            );
        }

        private setSignatureDateCoordinates ( stepName: string, coordinateData: any ) : void {

            var coordinateKeyPrefix = stepName === 'set-signature' ? 'signature' : 'date';

            var thisPage: any;
            this.agreement.pages.forEach( ( page: any, i: number ) => {
                if (page.selected) {
                    page[coordinateKeyPrefix + 'X']        = coordinateData.left / 2;
                    page[coordinateKeyPrefix + 'Y']        = coordinateData.top / 2;
                    page[coordinateKeyPrefix + 'Width']    = coordinateData.width / 2;
                    page[coordinateKeyPrefix + 'Height']   = coordinateData.height / 2;
                    thisPage = page;
                }
            });
        }

        public goToPage ( stepName: string ) : void {
            return this.loanerAgreementService.goToPage (this.$state, stepName);
        }

        private $destroy () : void {
            this.unwatchAgreement();
            this.unwatchAgreementPages();
        }
    }

    getDealerwareWebComponentsModule().controller(
        'SettingsLoanerAgreementViewDirectiveController',
        SettingsLoanerAgreementViewDirectiveController
    );


    export class SettingsLoanerAgreementViewDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'SettingsLoanerAgreementViewDirectiveController';
        public controllerAs     : string    =   'LAV';
        public bindToController : boolean   =   true;
        public templateUrl      : string    =   '/components/settings/loaner-agreement/view-directive.html';
        public scope            : Object    =   {
            parentController        : '=controller',
            loanerAgreementService  : '=',
            agreement               : '='
        };
    }

    getDealerwareWebComponentsModule().directive(
        'dealerwareSettingsLoanerAgreementView',
        ( ) => new SettingsLoanerAgreementViewDirective()
    );

}

